import HttpHelper from "../../helper";

export const fantasyEndpoints = {
  getRanking: (params, signal) =>
    HttpHelper.meloukAxios
      .get(`/fantasy-ranking`, {params, signal})
      .then((res) => res?.data)
      .catch((err) => err?.response?.data),
};